// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"20033":"css/styles","61411":"css/mail","96170":"css/app"}[chunkId] + ".css";
};